module.exports = __webpack_public_path__ + "img/LimitBee-2.d9214d51.png";